// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, PROD_SSR_GQL_ENDPOINT } from '../configs/constants';
import { normalizeHost } from '../utils/url';
import { buildIdCidadesGraphqlArg } from '../lib/region';
// SD-0020: nome público = nome_fantasia || empresa, aplicado UMA vez na carga do site (ver utils/nomePublico.ts)
import { aplicaNomePublico } from '../utils/nomePublico';

const getGraphqlRequestOrigin = (origin?: string) =>
    typeof window !== 'undefined' ? window.location.origin : origin || '';

const getSsrForwardedHostHeaders = (origin?: string) => {
    if (typeof window !== 'undefined') return {};

    const normalizedOriginHost = normalizeHost(origin || '');
    if (!normalizedOriginHost) return {};

    return {
        'x-forwarded-host': normalizedOriginHost,
    };
};

// requests
//Query para pegar todos os dados da home page
export async function allDataHomePage(origin?: string, codsite?: number, url?: any,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'site',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'site',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    // Campos NOVOS do site-graphql, cada grupo com a sua opção do CRM:
    //   - SD-0024 `whatsapp_tudo_imobiliaria` ("Enviar todos os botões de WhatsApp para o número da imobiliária");
    //   - 21/10 `seletor_idioma` + `preco_moeda_idioma` ("Adicionar campo de idioma no site" / "Alterar preço
    //     para moeda do idioma").
    // Um backend que ainda não conhece um campo (deploy fora de ordem, fallback do /api/gql para o
    // Worker) recusa o documento INTEIRO — por isso o documento tem formas e a repetição tira SÓ o
    // grupo recusado (sem o campo = opção desligada). A última forma é a de sempre.
    type CamposNovos = { whats: boolean; idioma: boolean };
    const documento = ({ whats: comWhatsImobiliaria, idioma: comIdiomaMoeda }: CamposNovos) => gql`
        {
            site {
                top_10
                redes_topo
                fb_id_pixel
                ocultar_endereco
                copyright
                EsconderRodapeSobressai
                internacional
                url_maps
                html_rodape
                titulo_automatico
                modelo_pagina_imovel
                modelo_pesquisa_popular
                modelo_topo
                ${comWhatsImobiliaria ? 'whatsapp_tudo_imobiliaria' : ''}
                ${comIdiomaMoeda ? 'seletor_idioma preco_moeda_idioma' : ''}
                modelo_cidades
                modelo_busca
                modelo_card
                abrirImovelNovaJanelaLista
                modelo_depoimento
                modelo_selection
                modelo_empresa
                modelo_blogs
                modelo_fundo
                modelo_equipe
                modelo_construtoras
                titulo_construtoras
                modelo_redes
                cards_busca
                mostrar_data_entrega
                afiliado_todo_site
                categoria_home
                caracteristicas_home
                titulo_card_1
                titulo_card_2
                titulo_card_3
                texto_card_1
                texto_card_2
                texto_card_3
                depoimento_imovel
                ver_url
                banner_imovel
                cidade_priorizada
                cidade_busca
                texto_botao_whats
                formulario_whats
                mostrar_mapa
                exibir_empreendimento
                moeda_tipo
                simulador
                ativa_logs
                casa_em_condominio
                carousel_temporada
                carousel_apartamento
                carousel_lancamentos
                exibir_cidade_bairro_no_imovel
                carousel_casa
                carousel_novidades
                titulo_c_top
                titulo_c_temporada
                titulo_c_novidades
                titulo_c_casas
                titulo_c_1
                titulo_c_2
                titulo_c_c_condominio
                titulo_c_apartamentos
                id
                modelo_novo
                ordenar_lista
                mostrar_visualizacoes
                site
                titulo
                meta_keywords
                meta_description
                url_logo
                url_icon
                url_video
                rodape
                texto_rodape
                cor1
                cor2
                cor3
                cor4
                cor5
                cor6
                cor7
                cor8
                cor9
                cor10
                cor11
                cor12
                cor13
                cor14
                cor15
                vgv_total
                total_imoveis
                total_cidades
                exibe_redes_sociais
                congelado
                qtd_fotos_bloqueios
                bloquear_fotos
                pixel_facebook_head
                fb_pixel_teste
                link_chat_body
                link_chat_head
                tag_google_head
                tag_google_body
                google_analytics_head
                google_analytics_body
                libera_fts_aluguel
                banner_home
                carrossel_corretores
                frase_busca
                frase_busca_2
                tamanho_logo
                logo_horizontal
                navbar_transparente
                transacoes
                contador_marca
                politica_privacidade
                termos_uso
                promocao
                Dados {
                    inicio_txt_descricao
                    delegar_ao_agenciador
                    horario
                    final_txt_descricao
                    empresa
                    nome_fantasia
                    email1
                    email2
                    email3
                    email4
                    tel1
                    tel2
                    tel3
                    tel4
                    estado
                    cep
                    tel1_nome
                    tel2_nome
                    tel3_nome
                    tel4_nome
                    tel1_whats
                    tel2_whats
                    tel3_whats
                    tel4_whats
                    endereco
                    cidade
                    bairro
                    creci
                    youtube
                    facebook
                    twitter
                    instagram
                    Linkedin
                    threads
                    tiktok
                    inicio_txt_descricao
                    final_txt_descricao
                }
                video
                widget_youtube
                widget_instagram
                marca_dagua {
                    opacidade
                    posicao
                    ativada
                    tamanho_marca
                }
                exibir_agenciador
            }
            videos {
                url_youtube
                excluido
            }
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
            allBanners {
                id
                codsite
                exibir
                ordem
                extensao
                titulo
                url
                url_link
                message
                ativo
            }
            banner_empresa {
                linkbanner
                card_titulo
                subtitulo_1
                paragrafo_1
                subtitulo_2
                paragrafo_2
                subtitulo_3
                paragrafo_3
                corconfig
            }
            menus {
                link
                titulo
                Destino
                Disponivel
                Menu
                Rodape
                Topo
                Conteudo
            }
            cidades {
                id
                nome
                id_estado
                url_foto
                imoveis
            }
            tipos {
                id
                nome
            }
            redes_sociais {
                nome
                href
                imagem
                seguidores
                arroba
            }
            construtoras {
                id
                nome
                url_foto
            }
            parceiros(mostrar_equipe: true) {
                id
                nome
                contador_atualizacao
                telefone
                telefone_2
                email
                mostrar_equipe
                descricao
                funcao {
                    id
                    nome
                }
                url_foto
                creci
                link_proprio
                instagram
                facebook
            }
            depoimentos {
                depoimento
                youtube
                cliente {
                    nome
                    foto
                }
            }
            precos_locacao {
                min
                max
            }
            precos_venda {
                min
                max
            }
            blogs {
                id
                url_foto
                autor
                titulo
                texto
                excluido
                data_cadastro
                id_cidade
                id_empreendimento
                categoria
                id_categoria
            }
            carrosseis {
                id_bairro
                id
                id_tipo
                id_categoria
                id_cidade
                id_caracteristica
                id_empreendimento
                preco_min
                preco_max
                url_red,
                titulo
                top_10
                novidades_semana
                personalizado
                exclusivos
                venda
                aluguel
                cor_fundo
                cor_degrade
                cor_font
                cor_botoes
            }
        }
    `;

    try {
        let data: any;
        let campos: CamposNovos = { whats: true, idioma: true };
        for (;;) {
            try {
                data = await graphQLClient.request(documento(campos));
                break;
            } catch (erroCampoNovo: any) {
                // só repete quando o backend RECUSOU campo novo (errors[] da resposta; a `message` do
                // ClientError traz a query inteira e casaria sempre). Timeout/erro geral → catch de sempre.
                // A validação do GraphQL lista TODOS os campos desconhecidos de uma vez: tira os grupos
                // recusados juntos (no máximo 1 repetição).
                const errosResposta = Array.isArray(erroCampoNovo?.response?.errors) ? erroCampoNovo.response.errors : [];
                const recusou = (nome: string) => errosResposta.some((e: any) => String(e?.message || '').includes(nome));
                const proximo: CamposNovos = {
                    whats: campos.whats && !recusou('whatsapp_tudo_imobiliaria'),
                    idioma: campos.idioma && !(recusou('seletor_idioma') || recusou('preco_moeda_idioma')),
                };
                if (proximo.whats === campos.whats && proximo.idioma === campos.idioma) throw erroCampoNovo;
                campos = proximo;
            }
        }
        // Corrige a extensão da URL do banner pela `extensao` REAL do arquivo. O backend
        // às vezes monta a url com `.jpg` fixo mesmo quando o arquivo é `.png` (ex.: banner
        // "home" do denisribeiroimoveis) → imagem 404 / banner quebrado. Normaliza num só
        // lugar (cobre home/menu/exclusivos/etc.) em vez dos hacks por-tenant nos componentes.
        if (Array.isArray(data?.allBanners) && data.allBanners.length) {
            data.allBanners = data.allBanners.map((b: any) => {
                const ext = String(b?.extensao || '').trim().toLowerCase();
                if (ext && typeof b?.url === 'string' && b.url) {
                    const fixed = b.url.replace(/\.(jpe?g|png|webp|gif)(\?.*)?$/i, `.${ext}$2`);
                    if (fixed !== b.url) return { ...b, url: fixed };
                }
                return b;
            });
        }
        // SD-0020: textos públicos usam o nome fantasia; a razão social fica em Dados.razao_social.
        if (data?.site) data.site = aplicaNomePublico(data.site);
        return data;
    } catch (error) {
        return null;
    }
}

// MULTI-REGIÃO: query pública `regioes` + `regioesConfig` + os vínculos de filial
// da equipe (site-graphql/legacy-public). Fica numa QUERY SEPARADA (não dentro de
// allDataHomePage) de propósito: enquanto o backend não expõe os campos, o GraphQL
// retornaria erro na query INTEIRA — e um erro no documento principal derrubaria o
// payload dos 300 tenants. Aqui o try/catch degrada pra
// `{regioes:[], config:null, filialIdsPorParceiro:{}}` (= tenant mono-região).
// NUNCA acrescentar estes campos ao documento `allDataHomePage`/`site`.
export type RegioesSiteResult = {
    regioes: any[];
    config: any | null;
    filialIdsPorParceiro: Record<string, number[]>;
};

const REGIOES_SITE_VAZIO: RegioesSiteResult = { regioes: [], config: null, filialIdsPorParceiro: {} };

export async function regioesSite(
    origin?: string,
    codsite?: number,
    prodOrigin?: any
): Promise<RegioesSiteResult> {
    if (!origin && typeof window === 'undefined') {
        return REGIOES_SITE_VAZIO;
    }

    let endpoint = BASE_URL;

    if (prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT;
    else
        endpoint = '/api/gql';

    const graphQLClient =
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'regioes',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'regioes',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    // "Nossa Empresa" por filial (foto + título do bloco): campos NOVOS do contrato
    // `regioes`. Vão no mesmo documento (1 request no caminho normal), mas um backend
    // que ainda não os conhece recusa a query INTEIRA — e o catch lá embaixo deixaria
    // o tenant sem filial nenhuma. Por isso o documento tem 2 formas e a 2ª tentativa
    // é a de sempre (sem os campos): a foto da filial é opcional, as filiais não.
    const documento = (comEmpresa: boolean) => gql`
        {
            regioes {
                id
                nome
                slug
                cidadeIds
                telefone
                whatsapp
                email
                seoTitle
                seoDescription
                filialId
                matriz
                videoUrl
                videoPosterUrl
                imagemUrl
                heroTitulo
                heroSubtitulo
                descricao
                endereco
                instagram
                ${comEmpresa ? 'empresaImagemUrl' : ''}
                ${comEmpresa ? 'empresaTitulo' : ''}
            }
            regioesConfig {
                modoEntrada
                lembrarDias
                tituloPopup
                subtituloPopup
            }
            parceiros(mostrar_equipe: true) {
                id
                filialIds
            }
        }
    `;

    try {
        let data: any;
        try {
            data = await graphQLClient.request(documento(true));
        } catch (erroEmpresa: any) {
            console.warn(
                '[regioesSite] documento com "Nossa Empresa" por filial recusado; repetindo sem os campos:',
                String(erroEmpresa?.response?.errors?.[0]?.message || erroEmpresa?.message || erroEmpresa).slice(0, 200)
            );
            data = await graphQLClient.request(documento(false));
        }
        const filialIdsPorParceiro: Record<string, number[]> = {};
        for (const p of Array.isArray(data?.parceiros) ? data.parceiros : []) {
            const id = Number(p?.id) || 0;
            if (!id) continue;
            const ids = Array.isArray(p?.filialIds)
                ? p.filialIds.map((v: any) => Number(v)).filter((v: number) => Number.isInteger(v) && v > 0)
                : [];
            filialIdsPorParceiro[String(id)] = ids;
        }
        return {
            regioes: Array.isArray(data?.regioes) ? data.regioes : [],
            config: data?.regioesConfig || null,
            filialIdsPorParceiro,
        };
    } catch (error) {
        // backend ainda sem os campos (ou erro qualquer) → tenant sem multi-região
        return REGIOES_SITE_VAZIO;
    }
}

// BUILDER: query pública `customCss` (site-graphql/legacy-public) — CSS custom do
// tenant publicado via Builder do CRM. Contrato: `{ customCss }` -> String|null.
// Backend em paralelo (pode ainda não existir) — try/catch degrada pra null, igual
// ao padrão de regioesSite: o site se comporta como hoje sem o campo.
export async function customCssSite(origin?: string, codsite?: number, prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if (prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT;
    else
        endpoint = '/api/gql';

    const graphQLClient =
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'customCss',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'customCss',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            customCss
        }
    `;

    try {
        const data: any = await graphQLClient.request(query);
        return typeof data?.customCss === 'string' ? data.customCss : null;
    } catch (error) {
        // backend ainda sem o campo (ou erro qualquer) → tenant sem CSS custom
        return null;
    }
}
// ORDEM DAS SEÇÕES da home publicada pelo Builder (query pública `sectionOrder`).
// Cópia deliberada do customCssSite acima: mesmos headers, mesmo fallback mudo —
// falhou, o site renderiza na ordem default (nunca em branco).
export async function sectionOrderSite(origin?: string, codsite?: number, prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if (prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT;
    else
        endpoint = '/api/gql';

    const graphQLClient =
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'sectionOrder',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'sectionOrder',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            sectionOrder
        }
    `;

    try {
        const data: any = await graphQLClient.request(query);
        return Array.isArray(data?.sectionOrder) ? (data.sectionOrder as string[]) : null;
    } catch (error) {
        // backend ainda sem o campo (ou erro qualquer) → tenant na ordem default
        return null;
    }
}

//Query para pegar os cards de busca
export async function cards_busca(origin?: string, codsite?: number, url?: any,prodOrigin?: any) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'cards_busca',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'cards_busca',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    const query = gql`
        {
            cards_busca {
                id
                nome
                url
                cor
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar os carrosseis de destaque da home
export async function carrosseis_destaque_home(
    origin?: string,
    codsite?: number,
    _url?: any,
    prodOrigin?: any,
    idCidades?: number[] | null
) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = PROD_SSR_GQL_ENDPOINT
    else
        endpoint = '/api/gql'

    const graphQLClient =
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'carrosseis_destaques',
            ...getSsrForwardedHostHeaders(origin)
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: getGraphqlRequestOrigin(origin),
            'x-graphql-client-name': getGraphqlRequestOrigin(origin),
            codsite: codsite ? codsite : 0,
            query: 'carrosseis_destaques',
            ...getSsrForwardedHostHeaders(origin)
        },
    });

    // MULTI-FILIAIS: `id_cidades` recorta os destaques às cidades da filial ativa.
    // Sem região o trecho sai VAZIO ⇒ query byte a byte igual à de hoje.
    const argIdCidades = buildIdCidadesGraphqlArg(idCidades).replace(/^,/, '');

    const query = gql`
        {
            carrosseis_destaque${argIdCidades ? `(${argIdCidades})` : ''} {
                id
                modelo
                titulo
                subtitulo
                descricao
                cor_fonte
                foto_banner
                posicao
                cor_titulos
                cor_degrade
                cor_fundo
                codsite
                ativo
                posts {
                    id
                    texto_botao
                    id_imovel
                    url_foto
                    descricao
                    url_redirect
                    target_blank
                    id_empreendimento
                }
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar informações para o rodapé
export async function allRodapes(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = BASE_URL;

    if(origin == codsite){
        endpoint = '/api/gql';
    }

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'allRodapes'
        },
    });

    const query = gql`
    {
        rodape {
            tipo
            cidade
            bairro
            dormitorios
            aluguel
            venda
            empreendimento
        }
    }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar todos os dados do site
export async function allDataSite(origin?: string, codsite?: number) {
    // if (!origin && typeof window === 'undefined') {
    //     origin = localStorage.getItem('dominio') || '';
    // }
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'allDataSite'
        },
    });
    const query = gql`
        {
            site {
                copyright
                EsconderRodapeSobressai
                internacional
                url_maps
                html_rodape
                titulo_automatico
                modelo_pagina_imovel
                modelo_topo
                modelo_cidades
                modelo_busca
                modelo_card
                abrirImovelNovaJanelaLista
                modelo_depoimento
                modelo_empresa
                modelo_blogs
                modelo_pesquisa_popular
                modelo_redes
                modelo_selection
                cards_busca
                mostrar_data_entrega
                afiliado_todo_site
                categoria_home
                caracteristicas_home
                titulo_card_1
                titulo_card_2
                titulo_card_3
                texto_card_1
                texto_card_2
                texto_card_3
                ativa_logs
                redes_topo
                top_10
                depoimento_imovel
                ver_url
                banner_imovel
                cidade_priorizada
                cidade_busca
                mostrar_mapa
                texto_botao_whats
                formulario_whats
                exibir_empreendimento
                moeda_tipo
                simulador
                casa_em_condominio
                carousel_temporada
                carousel_apartamento
                carousel_lancamentos
                exibir_cidade_bairro_no_imovel
                carousel_casa
                carousel_novidades
                titulo_c_top
                titulo_c_temporada
                titulo_c_novidades
                titulo_c_casas
                titulo_c_1
                titulo_c_2
                titulo_c_c_condominio
                titulo_c_apartamentos
                id
                modelo_novo
                ordenar_lista
                mostrar_visualizacoes
                site
                titulo
                meta_keywords
                meta_description
                url_logo
                url_icon
                url_video
                rodape
                texto_rodape
                cor1
                cor2
                cor3
                cor4
                cor5
                cor6
                cor7
                cor8
                cor9
                cor10
                cor11
                cor12
                cor13
                cor14
                cor15
                vgv_total
                total_imoveis
                total_cidades
                exibe_redes_sociais
                congelado
                qtd_fotos_bloqueios
                bloquear_fotos
                pixel_facebook_head
                fb_pixel_teste
                link_chat_body
                link_chat_head
                tag_google_head
                tag_google_body
                google_analytics_head
                google_analytics_body
                libera_fts_aluguel
                banner_home
                carrossel_corretores
                frase_busca
                frase_busca_2
                tamanho_logo
                logo_horizontal
                navbar_transparente
                transacoes
                contador_marca
                politica_privacidade
                termos_uso
                promocao
                Dados {
                    inicio_txt_descricao
                    horario
                    delegar_ao_agenciador
                    final_txt_descricao
                    empresa
                    nome_fantasia
                    email1
                    email2
                    email3
                    email4
                    tel1
                    tel2
                    tel3
                    tel4
                    tel1_nome
                    tel2_nome
                    tel3_nome
                    tel4_nome
                    tel1_whats
                    tel2_whats
                    tel3_whats
                    tel4_whats
                    endereco
                    cidade
                    bairro
                    creci
                    youtube
                    facebook
                    twitter
                    instagram
                    Linkedin
                    threads
                    tiktok
                    inicio_txt_descricao
                    final_txt_descricao
                }
                video
                widget_youtube
                widget_instagram
                marca_dagua {
                    opacidade
                    posicao
                    ativada
                    tamanho_marca
                }
                exibir_agenciador
            }
            cidades {
                id
                nome
                id_estado
                url_foto
                imoveis
            }
            rodape {
                tipo
                cidade
                bairro
                dormitorios
                aluguel
                venda
                empreendimento
            }
            tipos {
                id
                nome
            }
            redes_sociais {
                nome
                href
                imagem
                seguidores
                arroba
            }
        }
    `;

    try {
        
const data: any = await graphQLClient.request(query);
        // SD-0020: idem allDataHomePage — nome público no lugar da razão social.
        if (data?.site) data.site = aplicaNomePublico(data.site);
        return data;
    } catch (error) {
        return null;
    }
}

//Query para pegar se o site está congelado
export async function siteCongelado(origin?: string, codsite?: number,url?: string) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    let endpoint = '/api/gql';

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
        {
            site {
                congelado
            }
        }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
